// extracted by mini-css-extract-plugin
export default {"selected":"_6432de768e","un":"dfa9114287"};